import { CheckGreen } from "src/assets";
import { Box, Stack } from "@mui/material";
import Text from "src/components/Displays/Text";
import { Trans, useTranslation } from "react-i18next";
import { useSessionStorage } from "src/hooks/useSessionStorage";
import PrimaryButton from "src/components/Shared/PrimaryButton";
import { MicroFrontendDetails, SESSION_KEYS } from "src/consts/session";

const CompatibilitySuccess = () => {
  const { t } = useTranslation();

  const [getMicroFrontendDetails] = useSessionStorage<MicroFrontendDetails>(
    SESSION_KEYS.MICRO_FRONTEND_DETAILS,
  );
  const [isCompCheckFromSell] = useSessionStorage<string>(
    SESSION_KEYS.IS_COMP_CHECK_FROM_SELL,
  );
  const [getRedirectUrl] = useSessionStorage<string>(SESSION_KEYS.REDIRECT_URL);

  const handleSubmit = async () => {
    const isCompCheckFromSellValue = isCompCheckFromSell();
    if (isCompCheckFromSellValue && isCompCheckFromSellValue === "true") {
      const redirectUrl = getRedirectUrl();
      if (redirectUrl) {
        window.location.href = redirectUrl;
      }
      return;
    }

    const sessionData = getMicroFrontendDetails();
    if (sessionData) {
      window.location.href = sessionData.callbackUrlSuccess;
    }
  };

  return (
    <Stack gap={5}>
      <Stack gap={2}>
        <Stack>
          <CheckGreen />
        </Stack>

        <Text
          text={t("page.compatibilitySuccess.pageTitle")}
          sx={(theme) => ({
            fontWeight: 500,
            fontSize: "32px",
            color: "#317D5B",
            lineHeight: "40px",
            fontFamily: "officina",
          })}
        />
      </Stack>

      <Text
        text={t("page.compatibilitySuccess.pageSubTitle1")}
        sx={(theme) => ({
          fontSize: "14px",
          lineHeight: "24px",
          fontFamily: "Inter",
          color: theme.palette.mainFont.primary,
        })}
      />

      <Text
        text={
          <Trans
            i18nKey={
              t(
                "page.compatibilitySuccess.pageSubTitle2",
              ) as "page.compatibilitySuccess.pageSubTitle2"
            }
            t={t}
            components={{ bold: <strong /> }}
          />
        }
        sx={(theme) => ({
          fontSize: "14px",
          lineHeight: "24px",
          fontFamily: "Inter",
          color: theme.palette.mainFont.primary,
        })}
      />

      <Box>
        <PrimaryButton
          onClick={handleSubmit}
          text={t("page.compatibilitySuccess.backBtnText")}
        />
      </Box>
    </Stack>
  );
};

export default CompatibilitySuccess;
